export default __webpack_public_path__ + "static/media/icon-voir.56c6ae9e.svg";